// Mobile menu toggle and header scroll state. Mirrors the merchantflow.ai
// Navbar: the menu is a panel that drops under the bar, and the bar turns
// white with a shadow once the page scrolls past 20px.
export default function menuOpen() {
    const header = document.getElementById('gh-head');
    const burgerButton = document.querySelector('.gh-burger');
    const panel = document.getElementById('gh-head-mobile');

    if (header) {
        let ticking = false;
        const update = () => {
            ticking = false;
            header.classList.toggle('is-scrolled', window.scrollY > 20);
        };
        update();
        window.addEventListener('scroll', () => {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(update);
            }
        }, { passive: true });
    }

    if (!burgerButton || !panel) return;

    const setOpen = (isOpen) => {
        document.body.classList.toggle('gh-head-open', isOpen);
        burgerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        burgerButton.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        panel.inert = !isOpen;
    };

    burgerButton.addEventListener('click', () => {
        setOpen(!document.body.classList.contains('gh-head-open'));
    });

    panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.body.classList.contains('gh-head-open')) {
            setOpen(false);
            burgerButton.focus();
        }
    });
}
